import { Router } from './Router';
class RouterFacade {
    navigate(to) {
        Router.getInstance().navigate(to);
    }
    listen(fn) {
        Router.getInstance().listen(fn);
    }
    removeListen(fn) {
        Router.getInstance().removeListen(fn);
    }
}
export const router = new RouterFacade();
